import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractNumericInput} from "../abstract-numeric-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterNumericInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-numeric-input",
    styleUrls: ["./filter-numeric-input.component.scss"],
    templateUrl: "./filter-numeric-input.component.html"
})
export class FUIFilterNumericInputComponent extends FUIAbstractNumericInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
